export function hhmmssFilter() {
  function filter(input) {
    var zpad = (input, n) => {
      if(angular.isUndefined(input))
        input = "";
      if(input.length >= n)
        return input;
      var zeros = "";
      for(var i = 0; i < n; i++) {
        zeros+="0";
      }
      if(input.toString().length > n) {
        return input;
      }
      else {
        return (zeros + input).slice(-1 * n);
      }
    };
    var hours = input.years() * 12 * 31 * 24 + input.months() * 31 * 24 + input.days() * 24 + input.hours();
    return `${zpad(hours,2)}:${zpad(input.minutes(),2)}:${zpad(input.seconds(),2)}`;
  }
  return filter;
}
